export const cibFolderStorage = [
  '512 512',
  `
  <path fill="#6b7785" stroke="none" d="M472,472H40a24.028,24.028,0,0,1-24-24V64A24.028,24.028,0,0,1,40,40H226.667a23.935,23.935,0,0,1,22.154,14.77L269.333,104H472a24.028,24.028,0,0,1,24,24V448A24.028,24.028,0,0,1,472,472Z"/>
  <path fill="none" stroke="#000" stroke-width="26" stroke-linejoin="round"
        d="M472,472H40a24.028,24.028,0,0,1-24-24V64A24.028,24.028,0,0,1,40,40H226.667a23.935,23.935,0,0,1,22.154,14.77L269.333,104H472a24.028,24.028,0,0,1,24,24V448A24.028,24.028,0,0,1,472,472Z"/>
  `,
]
